import { Button as AntDButton } from 'antd';
import type { ReactNode } from 'react';

import Link from '~/shared/components/link';

type ButtonPropsType = {
  disabled?: boolean;
  block?: boolean;
  className?: string;
  htmlType?: 'submit' | 'button' | 'reset';
  size?: 'small' | 'middle' | 'large' | undefined;
  href?: string;
  id?: string;
  type?: 'text' | 'link' | 'default' | 'primary' | 'dashed';
  children: ReactNode;
  icon?: ReactNode;
  style?: Record<string, unknown>;
  target?: string;
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
};

const Button = ({
  children,
  icon,
  block = false,
  className,
  size = 'small',
  htmlType = 'button',
  href,
  title,
  style,
  type = 'text',
  onClick,
  id,
  target,
  disabled,
}: ButtonPropsType) =>
  onClick || htmlType === 'submit' ? (
    <AntDButton
      disabled={disabled}
      className={className}
      id={id}
      style={style}
      icon={icon}
      size={size}
      block={block}
      htmlType={htmlType}
      title={title}
      onClick={onClick}
      type={type}
    >
      {children}
    </AntDButton>
  ) : (
    <Link itemProp="url" href={href as unknown as URL} tabIndex={0} target={target} role="button" style={style}>
      {type && (
        <AntDButton
          disabled={disabled}
          icon={icon}
          className={`main-button ${className}`}
          id={id}
          size={size}
          htmlType={htmlType}
          block={block}
          style={style}
          title={title}
          onClick={onClick}
          type={type}
        >
          {children}
        </AntDButton>
      )}
      {!type && children}
    </Link>
  );

export default Button;
